

















import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class ExtraKeyboardKey extends Vue {
  // noinspection JSUnusedGlobalSymbols
  $event!: Event;

  @Prop() id!: string;
  @Prop() shifted: boolean = false;
  @Prop() disabled!: boolean;

  get keyLabel(): string {
    // return upcase/downcase key label based on shift status
    const { shifted }: { shifted: boolean } = this;
    switch (this.id) {
      case 'shift':
        return shifted ? '\u21EA' : '\u21E7';
      case 'aumlaut':
        return shifted ? '\u00C4' : '\u00E4';
      case 'oumlaut':
        return shifted ? '\u00D6' : '\u00F6';
      case 'uumlaut':
        return shifted ? '\u00DC' : '\u00FC';
      case 'eszett':
        return '\u00DF';
      default:
        Vue.$log(`ExtraKeyboardKey unknown key ${this.id}`, this);
        return this.id;
    }
  }
}
